export { default } from "./ErrorCaught";
